export default {
    baseUrl: 'https://acc.calmos.myapps.biorius.com/api',
    notificatorUrl: 'https://localhost:8000',
};
  